import catalogRoutes from './catalogs';
import authRoutes from './auth';
import sellableStudentExamsRoutes from './sellableStudentExamsRoutes';
import studentExams from './studentExam';
import batchActionsRoutes from './batchActions';

export default [
  catalogRoutes,
  sellableStudentExamsRoutes,
  studentExams,
  batchActionsRoutes,
  authRoutes,
];
